/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconSprout: {
  name: 'sprout';
  data: string;
} = {
  name: 'sprout',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M371.355 235.331c.251-3.385.368-6.772.322-10.152-.917-66.645-62.699-130.3-62.699-130.3h-.001v.002s-59.947 69.638-59.028 136.284c.011.781.038 1.561.065 2.341C194.01 160.102 115.065 121.67 16.919 121.67c0 0 .601 114.979 75.958 175.917 44.179 35.724 119.896 35.882 159.016 60.735 61.633 39.151 26.114 154.371-38.333 242.933h193.799c-64.93-89.22-99.789-204.495-37.625-243.63 39.435-24.825 115.187-24.592 159.016-60.035 75.357-60.938 75.958-175.917 75.958-175.917-110.668 0-182.488 44.881-233.353 113.658z"/></svg>`,
};
